import { useQuery } from '@apollo/client'
import React, { useContext } from 'react'

import { GET_ORDER_PRODUCTS } from '../../../../../graphql/queries/Products'
import { TokenContext } from '../../../../../layouts/context'
import { monthDayYear } from '../../../../../utils/dateTools'
import Spinner from '../../../../Spinner'
import ShipmentItem from '../ShipmentItem'
import { Fulfillment } from '../types'
import {
  DetailLabel,
  DetailLink,
  DetailsContainer,
  DetailValue,
  ShipmentContainer,
  ShipmentDetail,
  ShipmentHeader,
  ShipmentItems,
  ShipmentTrackingNumber,
} from './styled'

interface ShipmentProps {
  fulfillment: Fulfillment
  fulfillmentNumber: number
  hasMultipleShipments: boolean
  className?: string
}

const Shipment: React.FC<ShipmentProps> = ({
  fulfillment,
  fulfillmentNumber,
  hasMultipleShipments,
  className = '',
}) => {
  const token = useContext(TokenContext)

  const { loading, data } = useQuery(GET_ORDER_PRODUCTS, {
    context: { token },
    variables: { sku: fulfillment.items.map((item) => item.sku) },
  })

  return loading ? (
    <Spinner loading />
  ) : (
    <ShipmentContainer className={className}>
      <ShipmentHeader>Shipment{hasMultipleShipments && ` #${fulfillmentNumber}`} </ShipmentHeader>
      <DetailsContainer>
        <ShipmentDetail>
          <DetailLabel>Status:</DetailLabel>
          <DetailValue>{fulfillment.status}</DetailValue>
        </ShipmentDetail>
        <ShipmentDetail>
          <DetailLabel>Shipped from:</DetailLabel>
          <DetailValue>{fulfillment.warehouseLocation}</DetailValue>
        </ShipmentDetail>
        <ShipmentDetail>
          <DetailLabel>
            {fulfillment.trackingLink ? 'Tracking Link:' : 'Tracking #(s):'}
          </DetailLabel>
          {fulfillment.trackingLink ? (
            <DetailLink href={fulfillment.trackingLink} target="_blank" rel="noreferrer">
              {fulfillment.trackingLink}
            </DetailLink>
          ) : (
            <DetailValue>
              {fulfillment?.trackingNumber?.split('<BR>').map((trackingNum, i, trackingNums) => (
                <ShipmentTrackingNumber key={i}>
                  {trackingNum}
                  {i !== trackingNums.length - 1 && ','}
                </ShipmentTrackingNumber>
              )) ?? 'N/A'}
            </DetailValue>
          )}
        </ShipmentDetail>
        <ShipmentDetail>
          <DetailLabel>Date shipped:</DetailLabel>
          <DetailValue>{monthDayYear(fulfillment.date)}</DetailValue>
        </ShipmentDetail>
        <ShipmentDetail>
          <DetailLabel>Shipped via:</DetailLabel>
          <DetailValue>{fulfillment.shipMethod}</DetailValue>
        </ShipmentDetail>
      </DetailsContainer>

      <ShipmentItems>
        {fulfillment.items.map((item) => (
          <ShipmentItem key={item.sku} item={item} products={data?.products?.items} />
        ))}
      </ShipmentItems>
    </ShipmentContainer>
  )
}

export default Shipment
